import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonConfigModal } from '../../../modals';
import { BanksService } from '../../../services/common/banks.service';
import { ToasterService } from '../../../services/common/toaster.service';

@Component({
  selector: 'app-bank-Account',
  templateUrl: './bankAccount.component.html',
  styleUrl: './bankAccount.component.scss'
})
export class BankAccountComponent implements OnChanges {
  buttonConfig = new ButtonConfigModal()
  @Input() customerData: any;
  @Output() customerDataUpdated = new EventEmitter<any>();
  showaddUpdateModal: boolean = false;
  currentSelectedBank: any;
  bankSupportData: any;
  bankAccountList: any;
  context: string = '';

  constructor(private bankService: BanksService, private toasterService: ToasterService) { }

  ngOnInit() {
    this.bankAccountList = [];
    this.buttonConfig.showAddButton = true
    this.buttonConfig.showExportButton = false
    this.getBankList();
  }

  /**
   * Detect changes to customerData input
   * Reload bank accounts if the input reference changed (which means data was updated)
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['customerData'] && !changes['customerData'].firstChange) {
      // customerData reference changed, which means source was updated
      // Reload bank accounts from the fresh customerData
      this.getBankList();
    }
  }

  /**
   * On change bank modal state from grid to edit a individual bank details
   * @param bankModal parameter passed to have a action on appropriate key
   */
  changeAddUpdateModelState(bankModal?: any) {
    if (bankModal?.showaddUpdateModal) {
      this.currentSelectedBank = {
        "currentRecord": bankModal?.currentSelectedRecord
      }
      // Set context when modal opens
      this.context = bankModal?.context || 'add';
    } else {
      // Clear context when modal closes
      this.context = '';
      this.currentSelectedBank = null;
    }

    this.showaddUpdateModal = bankModal?.showaddUpdateModal;

    // Update or add bank account if submitted successfully
    if (bankModal?.isSubmitted === true && bankModal?.savedBankAccount) {
      const existingIndex = this.bankAccountList?.findIndex((acc: any) =>
        acc.id === bankModal.savedBankAccount.id
      );

      if (existingIndex > -1) {
        // Update existing account
        this.bankAccountList[existingIndex] = bankModal.savedBankAccount;
      } else {
        // Add new account
        this.bankAccountList = [...(this.bankAccountList || []), bankModal.savedBankAccount];
      }

      // Update the source customerData.bankAccounts so tabs refresh properly
      this.customerData.bankAccounts = this.bankAccountList;

      // Emit updated customerData back to parent component (client-addupdate)
      // Create a NEW object reference to ensure change detection fires in ngOnChanges
      this.customerDataUpdated.emit({ ...this.customerData });
    }
  }

  /**
   * getting the bank list
   */
  getBankList() {
    this.bankAccountList = this.customerData?.bankAccounts?.map((data: any) => {
      return data;
    });
  }

  /**
   * Delete a bank account record
   */
  onDeleteBankAccount(bank: any): void {
    if (confirm(`Are you sure you want to delete this bank account (${bank.bankName || 'bank account'})?`)) {
      this.bankService.deleteBankAccount(bank.id).subscribe({
        next: () => {
          this.toasterService.showSuccess('Bank Account deleted successfully');
          // Remove from local list
          this.bankAccountList = this.bankAccountList.filter((acc: any) => acc.id !== bank.id);
          this.customerData.bankAccounts = this.bankAccountList;
          this.customerDataUpdated.emit({ ...this.customerData });
        },
        error: (error) => {
          console.error('Delete bank account failed:', error);
          this.toasterService.showError('Failed to delete bank account');
        }
      });
    }
  }

}
